import { render, staticRenderFns } from "./CouponDialog.vue?vue&type=template&id=18149eb7&scoped=true&"
import script from "./CouponDialog.vue?vue&type=script&lang=ts&"
export * from "./CouponDialog.vue?vue&type=script&lang=ts&"
import style0 from "./CouponDialog.vue?vue&type=style&index=0&id=18149eb7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18149eb7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VDialog})
